import PeopleRequests from './PeopleRequests'
import enhance from './PeopleRequests.enhancer'

export default enhance(PeopleRequests)

export const requestColumns = [
  {
    width: 20, field: 'select', selectable: true, format: 'checkbox'
  },
  {
    width: 200, label: 'Name', field: 'fullName', format: 'name',
  },
  {
    width: 225, label: 'Email', field: 'email',
  },
  {
    width: 150, format: 'fullDate', label: 'Time of request', field: 'joinedAt',
  },
  {
    width: 100, format: 'approval', label: 'Approval', selectable: false, hideHeader: true
  }
]



// WEBPACK FOOTER //
// ./src/containers/people/PeopleRequests/index.js